import React from 'react'

const Paddy = (props) => (
    <section className={`paddy ${props.name}`}>
        {props.title ? <h1 className="low-key">{props.title}</h1> : <hr className="useless"/>}
        {props.children}
    </section>
)

export default Paddy;